import React, { useState, useEffect } from "react";
// import BASE_URL from "../../Constants/config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addSelectedUsers } from "../../Redux/store/selectedUserSlice";
import { useToast } from "../../Utils/toastContext";

const AddUserPopup = ({ onClose, setactualData }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();

  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [users, setusers] = useState([]);
  const navigate = useNavigate();

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getUsers = async () => {
    try {
      const response = await GetAPIcalls("/v1/user/admin/all-users");

      if (response.status == 200) {
        setusers(response.data.users);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getUsers();
  }, []);
  const filteredUsers = users.filter(
    (user) =>
      user.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.unique_id.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const addUserToTable = (user) => {
    if (!selectedUsers.some((selected) => selected.id === user.id)) {
      setSelectedUsers([...selectedUsers, user]);
      setSearchTerm("");
    }
  };
  const toggleTableSelection = (userId) => {
    setSelectedUsers((prevSelected) =>
      prevSelected.some((user) => user.id === userId)
        ? prevSelected.filter((user) => user.id !== userId)
        : prevSelected
    );
  };
  const addFinalusers = async (e) => {
    e.preventDefault();
    let newArray = [];
    selectedUsers.map((user) => dispatch(addSelectedUsers(user.id)));
    setactualData(newArray);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-auto">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-6">
        <h2 className="text-lg font-medium mb-4 text-center">Add User</h2>

        {/* Search Box */}
        <label htmlFor="refId" className="mb-1 text-sm text-labelColour">
          Search Name or ID
        </label>
        <div className="relative mb-4">
          <input
            type="text"
            className="lg:w-[400px] w-full  px-4 py-2 border rounded-lg text-sm pl-10"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            <img
              src="/search-normal.svg"
              alt="Close Icon"
              className="h-3 w-3"
            />
          </span>

          {/* Dropdown */}
          {searchTerm && (
            <div className="absolute mt-2 lg:w-[400px] w-full bg-white border rounded-lg shadow-lg z-50 overflow-hidden">
              {filteredUsers.map((user) => (
                <div
                  key={user.id}
                  className="flex items-center justify-between px-4 py-2 hover:bg-black hover:text-white cursor-pointer"
                  onClick={() => addUserToTable(user)}
                >
                  <div className="flex items-center space-x-2">
                    <span className="block w-8 h-8 rounded-full bg-gray-300">
                      <img
                        src="/avatar.svg"
                        alt="Close Icon"
                        className="h-8 w-8"
                      />
                    </span>
                    <div>
                      <p className="text-sm font-medium">
                        {user.first_name} {user.last_name}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span
                      className={`px-2 py-1 text-xs rounded-xl ${
                        user.user_type.includes("CUSTOMER")
                          ? "bg-blue-100 text-blue-600"
                          : user.user_type.includes("AGENT")
                          ? "bg-orange-100 text-orange-600"
                          : "bg-green-100 text-green-600"
                      }`}
                    >
                      {user.user_type}
                    </span>
                    <p className="text-xs">${user.unique_id}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Table */}
        <div className="overflow-x-auto mt-4">
          <table className="min-w-full border-t border-gray-200">
            <thead className="text-[#8C8C8C] border-b border-gray-200 text-sm font-medium">
              <tr>
                <th className="px-4 py-2 text-left"></th>
                <th className="px-4 py-2 text-left"></th>

                <th className="px-4 py-2 text-center font-medium">Name</th>
                <th className="px-4 py-2 text-center"></th>
                <th className="px-4 py-2 text-center font-medium">ID</th>
                <th className="px-4 py-2 text-center font-medium">
                  Cash Account
                </th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {selectedUsers.map((user, index) => (
                <tr key={user.id} className="border bg-[#E8F1F8] border-black">
                  <td className="px-4 py-2">
                    <input
                      type="checkbox"
                      id="selectUser"
                      checked={selectedUsers.some((u) => u.id === user.id)}
                      onChange={() => toggleTableSelection(user.id)}
                      className="custom-checkbox h-3 w-3 rounded"
                    />
                  </td>
                  <td className="px-4 py-2 font-medium">{index + 1}</td>

                  <td className="px-4 py-2  font-medium flex items-center space-x-2">
                    <img
                      src="/avatar.svg"
                      alt={user.name}
                      className="w-8 h-8 rounded-full"
                    />
                    <span className="text-center">
                      {user.first_name} {user.last_name}
                    </span>
                  </td>
                  <td className="px-4 py-2 font-medium text-center">
                    <span
                      className={`px-2 py-1 text-xs rounded-xl ${
                        user.user_type.includes("CUSTOMER")
                          ? "bg-blue-100 text-blue-600"
                          : user.user_type.includes("AGENT")
                          ? "bg-orange-100 text-orange-600"
                          : "bg-green-100 text-green-600"
                      }`}
                    >
                      {user.user_type}
                    </span>
                  </td>
                  <td className="px-4 py-2 font-medium text-center">
                    {user.unique_id}
                  </td>
                  <td className="px-4 py-2 font-medium text-center">
                    ${user.cash_account}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex flex-col md:flex-row justify-center mt-4">
          <button
            className="px-10 py-2 border rounded-full mr-2 text-black border-black"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            onClick={(e) => addFinalusers(e)}
            className="px-8 py-2 bg-black md:mt-0 mt-2 text-white rounded-full"
          >
            Add Selected
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserPopup;
